import useWindowWidth from 'hooks/use-window-width';
import { MAP_PIN_LIMITS, DEFAULT_PIN_LIMITS } from 'constants/map-pin-limits';
import type { PinLimitConfig } from 'domain/map-pin/map-pin.types';

/**
 * Pure function: returns the pin limits for a given viewport width.
 * Exported separately for direct unit testing without React.
 */
export function getMapPinLimits(width: number): PinLimitConfig {
  for (const config of MAP_PIN_LIMITS) {
    if (width >= config.minWidth) {
      return config;
    }
  }
  return DEFAULT_PIN_LIMITS;
}

/**
 * Hook: returns { maxPins, fullPinThreshold } for the current viewport.
 */
export default function useMapPinLimits(): PinLimitConfig {
  const windowWidth = useWindowWidth();
  return getMapPinLimits(windowWidth);
}
